import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useOrderByIdQuery } from '../../../Store/Apis/bookingApi';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import formatDate from '../../../Hooks/formatDate';

const PrintStock = () => {
    const user = useSelector((state) => state.auth.user)
    const [logoLoaded, setLogoLoaded] = useState(false); // Track logo loading state
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('id');

    const orderByIdApi = useOrderByIdQuery({
        keyID: orderId
    }, {skip: !orderId});

    useEffect(() => {
        // Hide sidebar and header by adding CSS classes
        document.querySelector('aside.sidenav').style.display = 'none';
        document.querySelector('.sidenav.fixed-start + .main-content').style.marginLeft = '0';
        document.querySelector('.navbar-main').style.display = 'none';
    }, []);

    useEffect(() => {
        if (orderByIdApi.isSuccess && logoLoaded) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [orderByIdApi.isSuccess, window, logoLoaded]);

    if (!orderByIdApi.isSuccess) {
        return null;
    }

    return (
        <div className='card' id="invoice">
            <div className="card-body">
                <div className="page-wrapper" style={{ padding: 36 }}>
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <td colSpan="3">
                                    <h6>Customer</h6>
                                    <p className="mb-0">{orderByIdApi.data.data[0].customerName}</p>
                                    <p className="mb-0">{orderByIdApi.data.data[0].customerNumber}</p>
                                </td>
                                <td colSpan="2" className="text-end">
                                    <h6 className="fw-bold">
                                        <span>Order ID -</span>
                                        <span className="ms-2">{orderByIdApi.data.data[0].orderNumber}</span>
                                    </h6>
                                    <p className="mb-1">
                                        <span>Order Date:</span>
                                        <span className="fw-600 ms-2">{formatDate(orderByIdApi.data.data[0].orderDate)}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" className="text-center">
                                    <h4 className="text-uppercase my-3">Stock Requisition</h4>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="bg-light">
                                <th className="text-uppercase text-secondary text-dark px-3 text-sm">#</th>
                                <th className="text-uppercase text-secondary text-dark text-sm">Date</th>
                                <th className="text-uppercase text-secondary text-dark text-sm">Particulars</th>
                                <th className="text-uppercase text-secondary text-dark text-sm">QTY</th>
                                <th className="text-uppercase text-secondary text-dark text-sm">Remarks</th>
                            </tr>
                            {orderByIdApi.data.data[0].serviceTypeAndName.map((service, index) => (
                                <tr key={service.serviceID}>
                                    <td className="px-3 pb-5">{index + 1}</td>
                                    <td>
                                        {formatDate(orderByIdApi.data.data[0].orderDate)}
                                    </td>
                                    <td>
                                        <h6 className="mb-0">{service.serviceName}</h6>
                                        <p className="mb-0 text-sm">{service.productServiceName}</p>
                                        <p className="mb-0 text-sm">{service.serviceCode}</p>
                                    </td>
                                    <td>{service.quantity}</td>
                                    <td></td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="3">
                                    <img src={user?.logo} alt="" height={70} className='mb-2' onLoad={() => setLogoLoaded(true)} />
                                    <h6 className="text-uppercase fw-500 mb-2">{orderByIdApi.data.data[0].outletName}</h6>
                                    <p className="mb-0 text-sm">{orderByIdApi.data.data[0].outletPhone}</p>
                                    <p className="mb-0 text-sm">{orderByIdApi.data.data[0].outletAddress}</p>
                                </td>
                                <td colSpan="2" className="align-top">
                                    <div className="d-flex justify-content-between">
                                        <span>Authorisation:</span> 
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Manager Signature:</span>
                                    </div>
                                    <div className="d-flex justify-content-between fw-600">
                                        <span>Date:</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default PrintStock;
